import React from "react";
import cx from "classnames";

class Glyphicon extends React.Component {
  render() {
    let { children, className, glyph, icon, ...otherProps } = this.props;

    let baseClassName = "glyphicon";
    let glyphicon = "";

    if (glyph) {
      glyphicon = "glyphicon-" + glyph;
    }

    if (icon) {
      baseClassName = "icon";
      glyphicon = "icon-" + icon;
    }

    return (
      <span className={cx(baseClassName, glyphicon, className)} {...otherProps}>
        {children}
      </span>
    );
  }
}

export default Glyphicon;
